import { render, staticRenderFns } from "./ProgressListItem.vue?vue&type=template&id=b2a70dba&scoped=true&"
import script from "./ProgressListItem.vue?vue&type=script&lang=js&"
export * from "./ProgressListItem.vue?vue&type=script&lang=js&"
import style0 from "./ProgressListItem.vue?vue&type=style&index=0&id=b2a70dba&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a70dba",
  null
  
)

export default component.exports